import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { media } from 'styles/breakpoints';

const StyledContentLoader = styled(ContentLoader)`
  height: 244px;
  width: 400px;
  margin: 10px;

  ${media.small`
    margin: 25px;
  `};
`;

export default function ArticleLoader(props) {
  return (
    <StyledContentLoader
      height={244}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      speed={2}
      width={400}
    >
      <rect x="10" y="187" rx="3" ry="3" width="350" height="6.4" />
      <rect x="10" y="207" rx="3" ry="3" width="380" height="6.4" />
      <rect x="10" y="227" rx="3" ry="3" width="201" height="6.4" />
      <rect x="0" y="-45.95" rx="0" ry="0" width="400" height="209" />
    </StyledContentLoader>
  );
}



// WEBPACK FOOTER //
// ./src/components/ArticlePreview/ArticleLoader.js